module.exports = __webpack_public_path__ + "static/media/icons-solid-check-green.276c76df.svg";